import { ONBOARDING_URL } from "@/utils/http-common.js";
import axios from "axios";

class OnboardingService {
  static getToken() {
    return localStorage.getItem("appUserToken");
  }

  static async post(url, data) {
    try {
      const response = await axios.post(`${ONBOARDING_URL}${url}`, data, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  static async updateDbData(data) {
    const { onboardingStateId, ...newDataObj } = data;
    try {
      const token = this.getToken();
      const response = await axios.patch(
        `${ONBOARDING_URL}/onboardingstate/nextstate?onboardingStateId=${onboardingStateId}`,
        newDataObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async addToWaitList(data) {
    try {
      const token = this.getToken();
      const response = await axios.post(
        `${ONBOARDING_URL}/waitlist/add`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async onWaitList() {
    try {
      const token = this.getToken();
      const response = await axios.get(
        `${ONBOARDING_URL}/waitlist/on-waitlist`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async shouldSkipCreditCheck() {
    try {
      const token = this.getToken();
      const response = await axios.get(
        `${ONBOARDING_URL}/creditcheck/skip-step`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default OnboardingService;



// WEBPACK FOOTER //
// ./src/services/onboarding.js